
(function($){
    function debounce(func, wait, immediate) {
        var timeout;
        
        return function executedFunction() {
            var context = this;
            var args = arguments;
                
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
        
            var callNow = immediate && !timeout;
            
            clearTimeout(timeout);
        
            timeout = setTimeout(later, wait);
            
            if (callNow) func.apply(context, args);
        };
    };

    function toggleTransition($el, animated = true, enter) {
        $el.toggleClass('animated-transition', animated);
        setTimeout(() => {
            $el.toggleClass('in', enter);
        }, 20);
    }

    /// Sets a scroll event listener and updates css classes for animated elements
    function setupScrollAnimations($) {
        const $containers = $('.scroll-animation-container');
        if(!$containers.length) { return; }

        let $scrollAnimations = [];
        $containers.each((index) => {
            const $animations = $containers.eq(index).find('.scroll-animation');
            $animations.each((index, el) => {
                const $el = $(el);
                $el.css({ transitionDelay: 0.3 * index + 's' });
                $el.find('*').css({ transitionDelay: 0.3 * index + 's' });
            })
            $scrollAnimations.push($animations);
        })
        
        const $window = $(window);
        const $viewports = $('.custom-scroll-animations-viewport');
        
        const enterView = new Event('enterview');
        const exitViewTop = new CustomEvent('exitview', { detail: { edge: 'top' } });
        const exitViewBottom = new CustomEvent('exitview', { detail: { edge: 'bottom' } });

        var checkIfInView = (viewport) => {
            let isWindow;
            if(!viewport) {
                isWindow = true;
                viewport = $window;
            }
            return () => {
                const windowHeight = viewport.height();
                const windowTop = viewport.scrollTop();
                const windowBottom = windowTop + windowHeight;
                const bottomThreshold = windowBottom - (windowHeight / 2);
    
                $containers.each(function(index) {
                    const $el = $containers.eq(index);
                    const height = $el.outerHeight();
                    const top = isWindow ? $el.offset().top : $el[0].offsetTop;
                    const bottom = top + height;
                    
                    const elInView = (bottom > windowTop) && (top <= bottomThreshold );
                    const elNotVisible = !elInView && ((bottom <= windowTop) || (top >= windowBottom));
    
                    if( elInView ) {
                        if($el.hasClass('inview')) { return; }
                        $el.addClass('inview');
                        $el[0].dispatchEvent(enterView);
                        toggleTransition($el, true, true);
                    } else if (elNotVisible) {
                        if(!$el.hasClass('inview')) { return; }
                        $el.removeClass('inview');
                        $el[0].dispatchEvent(bottom <= windowTop ? exitViewTop : exitViewBottom);
                        if($el.hasClass('reset-animation-on-exit')) {
                            toggleTransition($el, false, false);
                        }
                    }
                });
            }
        };

        const debouncedWindowFunc = debounce(checkIfInView(), 10);
        const debouncedViewports = debounce(checkIfInView($viewports), 10);

        $window.on('scroll resize', debouncedWindowFunc);
        $viewports.on('scroll resize', debouncedViewports);

        $window.trigger('scroll');
        $viewports.trigger('scroll');
    }
    
    // Initialize everything
    $(document).ready(function($) {
        setupScrollAnimations($);
    }); 
})(jQuery);